export default __webpack_public_path__ + "static/media/money-bag-dollar.30fe7550.svg";